export default "__VITE_ASSET__CM66I5f1__"